
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { alertErrorMessage, alertSuccessMessage, confirmDelete } from "../../components/alert";


const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

 const [selectedImage, setSelectedImage] = useState(null);
 const [profileImageFile, setProfileImageFile] = useState(null);


 const [imageError, setImageError] = useState(false); // add this state




 const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status) {
          setProfile(response.data.data.profile);
          setFormData({
            name: response.data.data.profile.name,
            mobile: response.data.data.profile.mobile,
            email: response.data.data.profile.email,
          });
        }
      } catch (error) {
        console.error('Error fetching profile:', error);

        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // Token expired or unauthorized
          localStorage.removeItem('token'); // Clear token
          navigate('/login'); // Redirect to login page
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

 const handleSave = async () => {
  try {
    const token = localStorage.getItem('token');
    const form = new FormData();
    form.append('name', formData.name);
    form.append('mobile', formData.mobile);
    form.append('email', formData.email);
    if (profileImageFile) {
      form.append('profile_pic', profileImageFile); // <- key should match backend expectation
    }

    const response = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/updateProfile',
      form,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.status === true) {
      setIsEditing(false);
      setProfileImageFile(null); // Clear selected file
      // Swal.fire({
      //   title: 'Update Successful',
      //   text: response.data.message,
      //   icon: 'success',
      //   showConfirmButton: false,
      //   timer: 2000,
      // });

      alertSuccessMessage(response.data.message)
    } else {
      // Swal.fire({
      //   title: 'Update Failed',
      //   text: response.data.message || 'Something went wrong.',
      //   icon: 'error',
      // });
      alertErrorMessage(response.data.message)
    }
  } catch (error) {
    console.error('Error updating profile:', error);
    // Swal.fire({
    //   title: 'Error',
    //   text: 'Failed to update profile. Please try again.',
    //   icon: 'error',
    // });

    alertErrorMessage('Failed to update profile. Please try again.')
  }
};

const handleImageSelect = (e) => {
  const file = e.target.files[0];
  if (file) {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid File Type',
        text: 'Please choose only .png, .jpg, or .jpeg files.',
      });
      e.target.value = '';
      return;
    }

    setSelectedImage(URL.createObjectURL(file));
    setProfileImageFile(file);
    setImageError(false);
  }
};




if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);   if (!profile) return <div className="text-danger">Failed to load profile.</div>;

  return (
    <div className="container mt-5 p-5 border rounded bg-light shadow-lg" style={{ maxWidth: '800px' }}>
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div className="d-flex align-items-center">
            <div className="position-relative">
              {selectedImage && !imageError ? (
                <img
                  src={selectedImage}
                  className="rounded-circle border"
                  width="120"
                  height="120"
                  alt="Selected Profile"
                  onError={() => setImageError(true)} // fallback if broken
                />
              ) : profile?.filepath && !imageError ? (
                <img
                  src={profile.filepath}
                  className="rounded-circle border"
                  width="120"
                  height="120"
                  alt="Profile"
                  onError={() => setImageError(true)} // fallback if broken
                />
              ) : (
                // Default avatar
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center border bg-secondary"
                  style={{ width: '120px', height: '120px', color: 'white', fontSize: '40px' }}
                >
                  <i className="fas fa-user"></i>
                </div>
              )}

              {isEditing && (
                <>
                  <label
                    htmlFor="profileImageUpload"
                    className="position-absolute bottom-0 end-0 bg-white rounded-circle p-2 shadow"
                    style={{ cursor: 'pointer' }}
                  >
                    <i className="fas fa-pencil-alt text-primary"></i>
                  </label>
                  <input
                    id="profileImageUpload"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    style={{ display: 'none' }}
                    onChange={handleImageSelect}
                  />
                </>
              )}
            </div>

            <div className='mx-4'>
              <h5 className="mb-1">{profile.name}</h5>
              <p className="mb-0 text-muted">{profile.email}</p>
            </div>
        </div>

        {!isEditing && (
          <button
            className="btn btn-success btn-sm text-white"
            onClick={() => setIsEditing(true)}
          >
            <i className="fas fa-pencil-alt me-2"></i> Edit
          </button>
        )}

      </div>

      <form>
        <div className="row">
          <div className="col-md-12 my-5">
            <label className="form-label fw-bold">Full Name {isEditing && <span className="text-danger">*</span>}</label>
            <input
              type="text"
              name="name"
              className="form-control border-0 border-bottom"
              value={formData.name}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>

          <div className="col-md-6 mb-5">
            <label className="form-label fw-bold">Mobile Number {isEditing && <span className="text-danger">*</span>}</label>
            <input
              type="text"
              name="mobile"
              className="form-control border-0 border-bottom"
              value={formData.mobile}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>

          <div className="col-md-6 mb-5">
            <label className="form-label fw-bold">Email</label>
            <input
              type="email"
              name="email"
              className="form-control border-0 border-bottom"
              value={formData.email}
              onChange={handleChange}
              disabled // email stays disabled
            />
          </div>

          <div className="col-md-6 mb-5">
            <label className="form-label fw-bold">Department</label>
            <input
              type="text"
              className="form-control border-0 border-bottom"
              value={profile.department_name}
              disabled
            />
          </div>

          <div className="col-md-6 mb-5">
            <label className="form-label fw-bold">Designation (HOD / Teacher)</label>
            <input
              type="text"
              className="form-control border-0 border-bottom"
              value={profile.designation_name}
              disabled
            />
          </div>

          <div className="col-md-12 mb-5">
            <label className="form-label fw-bold">College Name</label>
            <input
              type="text"
              className="form-control border-0 border-bottom"
              value={profile.college_name}
              disabled
            />
          </div>
        </div>
      </form>
      {isEditing && (
  <div className="d-flex justify-content-start mt-4">
    <button
      type="button"
      className="btn px-4"
      onClick={handleSave}
      style={{ backgroundColor: '#5856d6', color: 'white' }}
    >
      Save Changes
    </button>
  </div>
)}

    </div>
  );
};

export default Profile;


